"use client";
import React, { useState, useEffect } from "react";
import useRecorder from "./useRecorder";
import axios from "axios";
import TranslatorInput from "./Translation";
const LanguageList = {
  "en-IN": "English",
  "hi-IN": "हिंदी [Hindi]",
  "te-IN": "తెలుగు [Telugu]",
  "ta-IN": "தமிழ் [Tamil]",
  "kn-IN": "ಕನ್ನಡ [Kannada]",
  "ml-IN": "മലയാളം [Malayalam]",
  "mr-IN": "मराठी [Marathi]",
  "gu-IN": "ગુજરાતી [Gujarati]",
  "bn-IN": "বাঙ্গালি [Bengali]",
  "ur-IN": "اردو [Urdu]",
  "ru-RU": "Русский [Russian]",
  "es-ES": "Español [Spanish]",
  "fr-BE": "Français [French]",
  "zh-TW": "中国人 [Chinese]",
  "ar-AE": "عربي [Arabic]",
  "pt-PT": "Português [Portuguese]",
  "su-ID": "basa Sunda [Sundanese]",
  "de-AT": "Deutsch [German]",
  "ja-JP": "日本 [Japanese]",
  "ko-KR": "한국인 [Korean]",
  "it-IT": "Italiano [Italian]",
  "tr-TR": "Türkçe [Turkish]",
  "ms-MY": "Melayu [Malay]",
};

const VirtualKeyboard = ({ lang }) => {
  let [
    audioURL,
    isRecording,
    startRecording,
    stopRecording,
    pause,
    setPause,
    setResume,
  ] = useRecorder();

  const [vkeyboard, setvkeyboard] = useState(false);
  const [sourceLanguage, setSourceLanguage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [Text, setText] = useState("");
  const [TransText, setTransText] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchText = async () => {
      let fileName = `aud.wav`;
      let fd = new FormData();
      const output = await axios({
        method: "get",
        url: audioURL, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
        responseType: "blob",
      });
      const selectedLang = sourceLanguage;
      let files = new File([output.data], fileName, { type: "audio/wav" });
      fd.append("file", files);
      fd.append("language", selectedLang);
      let config = {
        "Content-Type": "multipart/form-data",
      };
      axios.post("https://voiceapi.aicte-india.org/voice-to-text", fd)
        .then(async (res) => {
          setLoading(false);
          const textResponse = res.data;
          if (
            textResponse &&
            textResponse.data !== "" &&
            textResponse.data !== undefined
          ) {
            setText(textResponse.data.replace(/\.$/, ""));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    };
    if (audioURL !== undefined && audioURL !== "") {
      fetchText();
    }
  }, [audioURL]);

  return (
    <div>
      <div className="realtimevideoCnt">
        <>
          <div className="inputfrom" style={{ position: "relative" }}>
            <button
              onClick={(e) => { e.preventDefault(); setvkeyboard(!vkeyboard) }}
              className="button green purple"
            >
              Virtual Keyboard
            </button>
          </div>
          <br />
        </>
        {vkeyboard && (
          <div className="inputGroup">
            <TranslatorInput lang={lang} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VirtualKeyboard;
